import React, { FunctionComponent, useEffect, useState } from 'react';
import osm from '../../utils/osm-providers';
import 'leaflet/dist/leaflet.css';
import styles from './TextMap.module.scss';
import { Grid } from '@material-ui/core';
import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import HashtagName from './HashtagName';
import { loadAllCountries, loadHashtagCountriesMap } from 'app/Requests';
import InfluencerIcon from './InfluencerIcon';
import SelectInput from '../Form/Inputs/SelectInput';
import { _t } from 'app/utils/i18n';
import { CountryIcon, ExpandIcon, SearchIcon } from 'app/assets/images/icons';
import DotsMenu from '../DotsMenu';
import CardTitle from '../CardTitle';
import { Link } from 'react-router-dom';
import Loader from '../Loader';
import ReactSelectAutocomplete from '../Form/Inputs/ReactSelectAutocomplete';
import {
  entitiesApiRoutes,
  influencerApiRoutes,
} from 'influencers/utils/apiRoutes';
import { useQuery, useQueryClient } from 'react-query';
import MapsApi from './mapsApi';
import { path } from 'app/utils/path';
import { checkTranslated, removeHash } from 'app/utils/helpers';
import {
  navigateWithSearchState,
  savePrevSearchState,
} from 'app/utils/search-state';
import ServerError from '../ErrorBoundary/ServerError';
import MapContent from './MapContent';

interface Props {
  isInfluencerModule?: boolean;
  compId: string;
  data?: {
    id?: number;
    country_name: string;
    hashtag: string;
    lang: number;
    lat: number;
    image_url?: string;
    mentions: number;
    percentage: number;
  }[];
  api?: string;
  ids?: string[];
  showFilters?: boolean;
  mapTitle?: string;
  expandUrl?: string;
  currentModule?: string;
  allMaps?: boolean;
  allCountriesFilter?: boolean;
  isTrends?: boolean;
  withTest?: boolean;
  testIsLoading?: boolean;
  isReport?: boolean;
  customMapApis?: any[];
}
interface IconProps {
  name: string;
  fontSize?: number;
  image_url?: string;
  viewUrl: string;
}
const checkIfCurrentModuleInfOrEnt = (moduleName: string) =>
  ['influencers', 'entities'].includes(moduleName);

const TextMap: FunctionComponent<Props> = ({
  compId,
  showFilters,
  api,
  ids,
  mapTitle,
  data,
  expandUrl,
  currentModule,
  isInfluencerModule,
  allMaps,
  allCountriesFilter,
  isTrends,
  withTest,
  testIsLoading,
  isReport,
  customMapApis,
}) => {
  const mapRef = React.useRef(null);

  const queryClient = useQueryClient();
  const countriesOptions = queryClient.getQueryData('getCountries') as any;

  const { data: AllCountries, isLoading: AllCountriesIsLoading } = useQuery(
    'AllCountries',
    loadAllCountries,
  );

  const defaultCountriesIds = countriesOptions
    ?.filter((option: any) => option?.default)
    ?.map((i: any) => i.value);
  const [center] = useState({ lat: 26.115986, lng: 36.108681 });
  const [filters, setFilters] = useState<any>({
    ...ids,
    limit: 100,
    is_parent: isInfluencerModule !== undefined ? false : undefined,
    center: {
      latitude: center.lat,
      longitude: center.lng,
    },
    country_ids: defaultCountriesIds,
  });
  const [currentView, setCurrentView] = useState<{
    labe: 'string';
    value: 'string';
    moduleName: 'string';
    path: 'string';
  }>();
  const [renderInfluencerIcon, setRenderInfluencerIcon] = useState(() =>
    checkIfCurrentModuleInfOrEnt(currentModule || ''),
  );
  const [localData, setLocalData] = useState(data);
  const moduleName = window.location.pathname.split('/')?.[1];
  const isTrendModule = moduleName === 'trends' || isTrends;
  const renderMapApi = () => {
    const current: string = !allMaps
      ? api
      : currentView?.value || customMapApis?.[0].value || MapsApi[0].value;
    return isTrendModule && !current?.includes('trends')
      ? `trends/${current}`
      : current;
  };

  const {
    data: QData,
    isLoading,
    isError,
  } = useQuery(
    [
      'loadHashtagCountriesMap',
      {
        slug: renderMapApi(),
        body: filters,
      },
    ],
    loadHashtagCountriesMap,
    { enabled: typeof localData === 'undefined' },
  );
  const currentCountries = localData ? localData : QData;

  const fontSizeEquation = (hashtagPercent = 0) => 12 * (0.5 + hashtagPercent);
  const getIcon = ({ name, fontSize, id, image_url }: any) => {
    const icon = L.divIcon({
      className: 'custom-icon',
      html: renderInfluencerIcon
        ? ReactDOMServer.renderToString(
            <InfluencerIcon
              viewUrl={
                allMaps
                  ? `${currentView?.path}/${id}`
                  : currentModule == 'influencers'
                    ? `${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${id}`
                    : `${path.entities.ANALYZED_ENTITIES_DETAILS_URI}/${id}`
              }
              image_url={image_url}
              name={
                typeof name === 'string'
                  ? name
                  : checkTranslated(name?.original, name?.arabic)
              }
            />,
          )
        : ReactDOMServer.renderToString(
            <HashtagName
              hashName={
                typeof name === 'string'
                  ? name
                  : checkTranslated(name?.original, name?.arabic)
              }
              fontSize={fontSize}
              viewUrl={
                currentView?.path.includes('videos') ||
                currentView?.path.includes('posts')
                  ? `${currentView?.path}/${id}`
                  : allMaps
                    ? `${
                        currentView?.path || path.trends.HASHTAG_VIEW_URI
                      }/${id}/${
                        typeof name === 'string'
                          ? savePrevSearchState(name)
                          : savePrevSearchState(
                              checkTranslated(name?.original, name?.arabic),
                            )
                      }`
                    : currentModule == 'videos'
                      ? `${
                          isTrendModule
                            ? path.trends.VIDEO_VIEW_URI
                            : path.posts.YOUTUBE_POST_DETAILS_URI
                        }/${id}`
                      : `${
                          isTrendModule
                            ? path.trends.HASHTAG_VIEW_URI
                            : path.hashtags.HASHTAG_VIEW_URI
                        }/${id}/${
                          typeof name === 'string'
                            ? savePrevSearchState(removeHash(name))
                            : savePrevSearchState(
                                removeHash(
                                  checkTranslated(name?.original, name?.arabic),
                                ),
                              )
                        }`
              }
            />,
          ),
    });
    return icon;
  };
  const handleChangeFilters = (name: string) => (option: any) => {
    if (Array.isArray(option)) {
      const values = option?.map((item: any) => +item.value);
      setFilters((prevFilters: any) => ({
        ...prevFilters,
        [name]: values,
      }));
    }
    setLocalData(undefined);
  };
  // const getNewCountriesIds = useMutation(loadNewCountriesIDMap);
  let debounceTimer: number | undefined;
  const refetchHahtages = (newcenter: any, newbounds: any) => {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => {
      identifyCountriesInBBoundries(newbounds, newcenter);
    }, 1000);
  };
  const identifyCountriesInBBoundries = (newbounds: any, newcenter: any) => {
    const { _northEast, _southWest } = newbounds; //Data from ReactLeafet
    const { lat: NorthLat, lng: NorthLng } = _northEast;
    const { lat: SouthLat, lng: SouthLng } = _southWest;
    const { lat, lng } = newcenter;
    setFilters({
      ...filters,
      center: {
        latitude: lat,
        longitude: lng,
      },
      northeast: {
        latitude: NorthLat,
        longitude: NorthLng,
      },
      southwest: {
        latitude: SouthLat,
        longitude: SouthLng,
      },
    });
  };

  const handleChangeMapView = (props: any) => {
    setRenderInfluencerIcon(checkIfCurrentModuleInfOrEnt(props?.moduleName));
    setCurrentView(props);
  };
  useEffect(() => {
    if (customMapApis !== undefined) {
      setCurrentView(customMapApis[0]);
    }
  }, []);
  if (AllCountriesIsLoading && !withTest) return <Loader />;
  return (
    <ServerError requiredApiCalls={[isError]}>
      <div id={compId} data-testid="text-map">
        {mapTitle && <CardTitle compId={compId} title={mapTitle} />}
        <Grid className={styles.TextMap} id={`${compId}-filters-map`}>
          {showFilters && (
            <Grid
              item
              container
              spacing={2}
              className={styles.filters}
              id={`${compId}-filters`}
              data-testid="text-map-filters"
            >
              <Grid item md={3} sm={10} className={styles.mapSelect}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    {allCountriesFilter ? (
                      <SelectInput
                        name="country_ids"
                        icon={<CountryIcon />}
                        placeholder={_t('trends:Country')}
                        options={AllCountries}
                        isMulti
                        onChange={handleChangeFilters('country_ids')}
                        showDefaultValue
                      />
                    ) : (
                      <SelectInput
                        name="country_ids"
                        icon={<CountryIcon />}
                        placeholder={_t('trends:Country')}
                        options={countriesOptions as any}
                        isMulti
                        onChange={handleChangeFilters('country_ids')}
                        showDefaultValue
                      />
                    )}
                  </Grid>
                  {allMaps && (
                    <Grid item sm={6}>
                      <SelectInput
                        name="currentView"
                        placeholder={_t('basic:select_module')}
                        value={currentView as any}
                        onChange={handleChangeMapView}
                        options={customMapApis || MapsApi}
                        showDefaultValue
                      />
                    </Grid>
                  )}
                  {isInfluencerModule !== undefined && (
                    <Grid item sm={6}>
                      <ReactSelectAutocomplete
                        onChange={handleChangeFilters('category_ids')}
                        name="category_ids"
                        isMulti
                        icon={<SearchIcon />}
                        customFilters={{ is_parent: false }}
                        moduleName={
                          isInfluencerModule
                            ? influencerApiRoutes().categoryAutoComplete
                            : entitiesApiRoutes().categoryAutoComplete
                        }
                        placeholder={_t('basic:searchBy_category')}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid className={styles.Actions}>
                {expandUrl && (
                  <Link
                    className={styles.ActionBtn}
                    to={navigateWithSearchState(expandUrl, {
                      type: 'map',
                      currentModule: currentModule && currentModule,
                      data: renderMapApi(),
                      currentView: currentView && currentView?.moduleName,
                    })}
                  >
                    <ExpandIcon />
                  </Link>
                )}
                <Grid className={styles.ActionBtn}>
                  {!isReport && <DotsMenu id={compId} />}
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} className={styles.map} id={`${compId}-map`}>
            <MapContainer center={center} zoom={4.5} scrollWheelZoom={false}>
              <TileLayer ref={mapRef} attribution="" url={osm.maptiler.url} />
              {/* <GeoJSON /> */}
              {isLoading || testIsLoading ? (
                <div
                  className={styles.Loader__Holder}
                  data-testid="Loader__Holder"
                >
                  <Loader />
                </div>
              ) : (
                <MapContent
                  currentCountries={currentCountries}
                  getIcon={getIcon}
                  fontSizeEquation={fontSizeEquation}
                  refetchHahtages={refetchHahtages}
                />
              )}
            </MapContainer>
          </Grid>
        </Grid>
      </div>
    </ServerError>
  );
};

export default TextMap;
